<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:53:40
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 20:43:52
 * @name: 通讯录模块路由
 * @Description: 通讯录模块路由
 * @FilePath: \backstage\src\views\mailList\mailListRouter.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <keep-alive :include="cashRouters">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "mailListRouter",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    }
  }
};
</script>